import { render } from "./orderType.vue?vue&type=template&id=fbb00f70&scoped=true"
import script from "./orderType.vue?vue&type=script&lang=js"
export * from "./orderType.vue?vue&type=script&lang=js"

import "./orderType.vue?vue&type=style&index=0&id=fbb00f70&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-fbb00f70"

export default script